#import "@/components/common/ArticlePreviewFragment.gql"
#import "@/components/common/StoryPreviewFragment.gql"

fragment ArticleRowSlideFragment on articleRowSlide_Entry {
  id
  typeHandle
  heading
  backgroundGray
  articles {
    ...ArticlePreviewFragment
    ...StoryPreviewFragment
  }
}
